<template>
    <div
            class="coach-home-meeting"
            :class="{'coach-home-meeting-full': mode === 'full'}"
    >
        <h1>
            <i class="fas fa-child"></i>
            Séance en cours
        </h1>
        <b-card class="coach-meeting-card">
            <div
                    class="row coach-meeting-card-row"
                    @click="toMeeting()"
            >
                <div class="col-1 coach-meeting-card-col">
                    <i class="fas fa-heartbeat picto"></i>
                </div>
                <div class="col-7 coach-meeting-card-col">
                    <h2 class="text-left">
                        {{name}}
                    </h2>
                    <p class="small-text">
                        {{meeting.activite.ou.fullName}}
                    </p>
                </div>
                <div class="col-4 coach-meeting-card-col">
                    <p>
                        <i class="far fa-clock"></i>
                        {{ date.format('HH:mm') }}
                        -
                        {{ date.add(meeting.duration, 'm').format('HH:mm') }}
                    </p>
                    <p>
                        <i class="fas fa-users"></i>
                        {{meeting.reservations.length}} / {{meeting.capacity}}
                    </p>
                </div>
            </div>

            <div class="coach-meeting-card-buttons">
                <div class="row justify-content-center coach-card-buttons-row">
                    <div class="col coach-meeting-btn">
                        <b-btn
                                :to="{name: 'meeting-presence', params: {id: meeting.id}}"
                                class="body-buttons-btn"
                        >
                            <i class="fas fa-user-check"></i><br />
                            Présence
                        </b-btn>
                    </div>
                    <div class="col coach-meeting-btn">
                        <b-btn
                                :to="{name: 'meeting-presence', params: {id: meeting.id}}"
                                class="body-buttons-btn"
                        >
                            <i class="fas fa-star"></i><br />
                            Notes
                        </b-btn>
                    </div>
                    <div class="col coach-meeting-btn">
                        <b-btn
                                :to="{name: 'meeting-presence', params: {id: meeting.id}}"
                                class="body-buttons-btn"
                        >
                            <i class="fas fa-running"></i><br />
                            Exercices
                        </b-btn>
                    </div>
                    <div class="col coach-meeting-btn">
                        <b-btn
                                :to="{name: 'meeting', params: {id: meeting.id}}"
                                class="body-buttons-btn"
                        >
                            <i class="fas fa-edit"></i><br />
                            Modifier
                        </b-btn>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: 'home-middle-meeting',
        props: {
            meeting: Object,
            mode: {
                type: String,
                default: 'full'
            }
        },
        data: () => ({
            moment,
        }),
        methods: {
            toMeeting() {
                this.$router.push({name: 'meeting', params: {id: this.meeting.id}})
            }
        },
        computed: {
            date() {
                return moment(this.meeting.dateheure.date)
            },
            name() {
                const name = (this.meeting.name && this.meeting.name !== 'null') ? this.meeting.name : ''
                return [this.meeting.activite.typeactivite.name, this.meeting.activite.name, name].join(' ')
            },
        }
    }
</script>
